import React from 'react';
import TextLabel from "../../../Controls/TextLabel.mjs";
import Select from "react-select";
import {Form} from "reactstrap";
import ImWriteNewIcon from "../../../media/images/ImWriteNewIcon.mjs";

const G = window.glob;

const getPlayers = () => {
	const me = G.getStatus('Player')?.id ?? '-';
	const out = (G.getStatus('Players')||[])
		.filter( p => (p?.id && p?.name && p?.id !== me && ! p?.ext) )
		.map( p => { return {
			label: p.name + ((p.roles && p.roles.length) ? ` (${ p.roles.map(r=>r.name).join(', ').substring(0,40) })`: ''),
			value: p.id
		}});
	(G.getStatus('Groups')||[]).forEach( g => {
		if ( ! (g?.id && g?.name && g.players) ) return;
		if ( ! g.players.find( p => p.id === me ) ) return;
		out.push({
			value: 'group:'+g.id,
			label: ` 👥 [${ g.players.length }] ${g.name}`
		});
	});
	return out.sort( (a, b) =>
		(a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1)
	);
}

const NewChat = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			chosen: '',
			players: getPlayers()
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.uid = G.generateUid('NewChat');
	}
	onSubmit(evt) {
		try { evt.preventDefault() } catch (e) {}
		if ( ! this.state.chosen?.value ) return;
		this.props.openChat(this.state.chosen?.value);
	}
	render() {
		return(
			<div className={"ChatArea NewChat"} id={this.uid} key={this.uid}>
				<div className={"box-title"}>
					<ImWriteNewIcon />
					<span
						className={"closer"}
						onClick={ ()=> { this.props.openChat() }}
					/>
					<TextLabel value={"New chat"}/>
				</div>
				<div className={"box-wrap"}>
					<div className={"box-top-center"} style={{overflow:"hidden"}}>
						<div className={"box-big-icon"}>
							<ImWriteNewIcon/>
						</div>
						<div style={{width: 'min(calc(100% - 24px), 500px)'}}>
							<Form onSubmit={this.onSubmit}>
								<Select
									autoFocus={true}
									menuPortalTarget={document.body}
									styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
									placeholder={G.label('Choose')}
									value={this.state.chosen}
									options={this.state.players}
									onChange={(v) => {
										this.setState({chosen: v}, this.onSubmit );
									}}
								/>
							</Form>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default NewChat;